import Contact from '../components/Contact'
import SEO from '../components/SEO'

const ContactPage = () => {
    return (
        <>
            <SEO 
                title="Contact AL-KONDA Group | Get in Touch"
                description="Contact AL-KONDA Group for construction, logistics, and environmental services. Reach out to discuss your project needs and get expert consultation."
                keywords="contact AL-KONDA, get quote, construction inquiry, logistics services contact, Iraq"
                url="/contact"
            />
            <Contact />
        </>
    )
}

export default ContactPage
